import { Head, Link } from '@inertiajs/react'
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { ArrowLeft, User, Phone, Mail, FileText, Edit } from "lucide-react"
import { DealsTable } from "@/components/deals-table"
import { VerticalTable } from "@/components/vertical-table"
import { NotesDisplay } from "@/components/notes-display"
import { Agent } from '@/types/serializers'

interface Props {
  agent: Agent
  deals: any[]
}

export default function Show({ agent, deals }: Props) {
  return (
    <>
      <Head title={`Agent: ${agent.name}`} />
      <div className="">
        {/* Header with navigation and actions */}
        <div className="flex items-center justify-between border-b border-b-gray-100 p-4 mb-0">
          <div className="flex items-center space-x-4">
            <Link href="/agents">
              <Button variant="outline" size="icon">
                <ArrowLeft className="h-4 w-4" />
              </Button>
            </Link>
            <div>
              <h1 className="text-2xl font-bold tracking-tight">
                {agent.name}
              </h1>
              <p className="text-sm text-muted-foreground">
                Salesforce ID: {agent.salesforce_id}
              </p>
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <Link href={`/agents/${agent.id}/edit`}>
              <Button variant="outline" className="flex items-center space-x-2">
                <Edit className="h-4 w-4" />
                <span>Edit</span>
              </Button>
            </Link>
          </div>
        </div>

        {/* Main content */}
        <div className="">
          <div className="grid grid-cols-1 md:grid-cols-4 min-h-screen">
            {/* Main content area - with deals table */}
            <div className="md:col-span-3">
              <DealsTable
                title='Deals'
                showActions={false}
                hiddenColumns={["agent.name"]}
              />
            </div>

            {/* Right sidebar with agent information */}
            <div className="space-y-6 p-6 bg-gray-50/50 border-l border-l-gray-100 p-4 md:col-span-1 min-h-full">
              {/* Contact Information Card */}
              <VerticalTable
                title="Contact Information"
                icon={User}
                rows={[
                  { key: "Name", value: agent.name },
                  {
                    key: "Email",
                    value: agent.email ? (
                      <a href={`mailto:${agent.email}`} className="text-primary hover:underline">
                        {agent.email}
                      </a>
                    ) : null
                  },
                  {
                    key: "Phone",
                    value: agent.phone ? (
                      <a href={`tel:${agent.phone}`} className="text-primary hover:underline">
                        {agent.phone}
                      </a>
                    ) : null
                  }
                ]}
              />

              <NotesDisplay notes={agent.notes} />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
